// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbe_a bhl_i bhl_j","ColorVariants__color":"bbe_b bhl_rp","ColorVariants__more":"bbe_c bhl_vv"};